import index from '~/public/locales/ja/index.json';

const locales = { ...index };
export type LocalizeKey = keyof typeof locales;

export const isLocalizeKey = (v: unknown): v is LocalizeKey => {
  return (
    typeof v === 'string' &&
    Object.keys(locales).some((p) => {
      return p === v;
    })
  );
};
